// STAGE TYPES
export const StageTypesData = {
    INQUIRY: 'Inquiry',
    QUOTATION: 'Quotation',
    CANCELED: 'Canceled',
    COMPLETED: 'Completed',
};

export const STAGE_TYPES = {};

export const STAGE_TYPES_LIST = Object.keys(StageTypesData).map((key) => {
    STAGE_TYPES[key] = key;

    return {
        value: key,
        label: StageTypesData[key],
    };
});

export const CASE_NEXT_STAGES = {
    DEFAULT: [
        {
            value: STAGE_TYPES.INQUIRY,
            label: StageTypesData.INQUIRY,
        },
    ],
    INQUIRY: [
        {
            value: STAGE_TYPES.QUOTATION,
            label: StageTypesData.QUOTATION,
        },
        {
            value: STAGE_TYPES.CANCELED,
            label: StageTypesData.CANCELED,
        },
    ],
    QUOTATION: [
        {
            value: STAGE_TYPES.COMPLETED,
            label: StageTypesData.COMPLETED,
        },
        {
            value: STAGE_TYPES.CANCELED,
            label: StageTypesData.CANCELED,
        },
    ],
    COMPLETED: [
        {
            value: STAGE_TYPES.CANCELED,
            label: StageTypesData.CANCELED,
        }
    ]
};

// CASE TYPES
export const CaseTypesData = {
    INDIVIDUAL: 'Individual',
    CORPORATE: 'Corporate',
};

export const CASE_TYPES = {};

export const CASE_TYPES_LIST = Object.keys(CaseTypesData).map((key) => {
    CASE_TYPES[key] = key;

    return {
        value: key,
        label: CaseTypesData[key],
    };
});

// COMMISSION TYPES
export const CommissionTypesData = {
    AMOUNT: 'Amount',
    PERCENTAGE: 'Percentage',
};

export const COMMISSION_TYPES = {};

export const COMMISSION_TYPES_LIST = Object.keys(CommissionTypesData).map((key) => {
    COMMISSION_TYPES[key] = key;

    return {
        value: key,
        label: CommissionTypesData[key],
    };
});
export const RELATION_TYPES = [
    {
        value: 'SELF',
        label: 'Self',
    },
    {
        value: 'MOTHER',
        label: 'Mother',
    },
    {
        value: 'FATHER',
        label: 'Father',
    },
    {
        value: 'WIFE',
        label: 'Wife',
    },
    {
        value: 'HUSBAND',
        label: 'Husband',
    },
    {
        value: 'FRIEND',
        label: 'Friend',
    },
    {
        value: 'NEIGHBOR',
        label: 'Neighbor',
    },
    {
        value: 'SON',
        label: 'Son',
    },
    {
        value: 'DAUGHTER',
        label: 'Daughter',
    },
    {
        value: 'NIECE',
        label: 'Niece',
    },
    {
        value: 'NEPHEW',
        label: 'Nephew',
    },
    {
        value: 'COMPANY',
        label: 'Company',
    },
    {
        value: 'DIRECTOR',
        label: 'Director',
    },
    {
        value: 'PARTNER',
        label: 'Partner',
    },
    {
        value: 'CARETAKER',
        label: 'Caretaker',
    },
];